<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()" class='sm-clickable'>
        <ion-icon name='close'></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ communication.title }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *ngIf='communication.status == 1' class='sm-clickable ion-padding'>
    Delivered
  </div>

  <div *ngIf='communication.status == 0' class='sm-error ion-padding'>
    Delivery Failed
  </div>

  <ion-item>
    <div [innerHTML]="decodedContent"></div>
    <!-- <br/> -->
    <!-- {{ communication.datetime | salonMonsterDate: 'dddd, MMMM D, Y h:mm a' }}   -->
  </ion-item>
</ion-content>
